import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'
import { RouteComponentProps } from 'react-router-dom'
import { CalcProjectStore } from 'redux/reducers/calcProject'

import { getProjectId } from 'utils'

export interface InputProps extends RouteComponentProps<any> {
  authenticated: boolean
  calcProject: CalcProjectStore
}

export type Variables = {
  version: string
  projNr: string
  eleId: number
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

export const CALCULATION_MATERIAL_QUERY = gql`
  query getPosition($version: String!, $projNr: String!, $eleId: Float!) {
    getPosition(version: $version, projNr: $projNr, eleId: $eleId) {
      id
      amount
      materialCosts {
        materials {
          id: recId
          articleNumber
          producer
          product
          amount
          unit
          amountWithClipping
          clippingPercentage
          unitPrice
          totalPrice
          condition
        }
        totalPrice
      }
    }
  }
`

const withCalculationMaterialQuery = graphql<InputProps, Response, Variables, ChildProps>(
  CALCULATION_MATERIAL_QUERY,
  {
    name: 'positionData',
    options: (ownProps: InputProps) => {
      const { projectNumber } = ownProps.calcProject
      const { calculationId } = ownProps.match.params
      const projectId = getProjectId(ownProps)

      if (projectId && calculationId) {
        return {
          variables: {
            version: 'v1',
            projNr: projectId,
            eleId: Number(ownProps.match.params.calculationId),
          },
        }
      } else if (projectNumber && calculationId) {
        return {
          variables: {
            version: calculationId,
            projNr: projectNumber,
            eleId: 1,
          },
        }
      }
      return {}
    },
  },
)

export default withCalculationMaterialQuery
